export function useTripDuration({ dispatch, value, initValue }) {
  const onChange = (value) => {
    dispatch({ type: 'TRIP_DURATION_CHANGE', payload: value });
  };

  return { value, onChange, defaultValue: initValue };
}
